/**
 * Removes all known unused data from local storage
 */
export const cleanStorageFromOldData = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem('elyGtmUserSession');
  window.localStorage.removeItem('recentlyViewed');
};
